import Widget from './widget.model';
import TicketType from './ticket-type.model';
import AddOn from './add-on.model';
import PromoCode from './promo-code.model';
import Session from './session.model';
import Currency from './currency.model';
import BillingForm from './billing-form.model';
import TicketForm from './ticket-form.model';
import Tax from './tax.model';
import Event from './event.model';
import { Media } from './media.model';

// INTERFACE

export interface Cart {
    tickets: TicketType[];
    addons: AddOn[];
    promoCode: PromoCode
    promoCodeQty: number;
}

export interface Colors {
    background: string;
    title: string;
    text: string;
    link: string;
    font: string;
}

export interface Dates {
    type: DatesType;
    sessionsIds: string[];
    startDate: Date;
    endDate: Date;
    timeZone: string;
}

export interface FormFieldOptions {
    label: string;
    value: string;
    checked: boolean;
}

export interface GlobalStateObject {
    isNft: boolean;
    showSeatPlan: boolean;
    isMaintenance: boolean,
    hideEventInfos: boolean,
    isRegistration: boolean;
    allFree: boolean;
    totalIsZero: boolean;
    eventId: Event;
    sessions: null,
    session: Session;
    widget: Widget;
    widgetId: string;
    order: any;
    billingForm: TicketForm,
    currency: Currency;
    tickets: TicketType[];
    cart: Cart;
    insurance: AppPrice | null;
    generalAddOns: AddOn[];
    orderTicketForms: any;
    hasInsurance: boolean;
    tracking: {
        gtm: string | null
        pixel: string | null
        ga: string | null
    }
}

export interface Payment {
    referer: string;
    method: string;
    tracker: string;
    gateway: string;
    hasMultiplePayements: boolean;
    amountSteps: number;
}

export interface Place {
    name: string;
    address: string;
    address2: string;
    zipCode: string;
    city: string;
    countryId: string;
    lat: string;
    lng: string;
}
export interface AppPrice {
    amount: number;
    currency: string;
    floated: number;
    formatted: string;
    locale: string;
}

export interface Price {
    sellingPrice: number
    costPrice: string;
    commission: {
        flat: number;
        percentage: number;
        calculated: number;
    };
    currency: {
        isoCode: string;
        value: number;
    };
}

export interface Reduction {
    type: string;
    amount: number;
}

export interface RequestResponseList {
    data?: any[];
    pager?: {
        page?: number,
        pages?: number
    };
    succes?: string;
    msg?: string;
    total?: number;
}

export interface SetCartModel {
    quantity: number;
    ticket: TicketType;
}

export interface SetKeyModel {
    value: any;
    key: string;
}

export interface Size {
    autoHeight: boolean;
    height: number;
}

export interface TermAndConditions {
    url: string;
    text: string;
}

export interface TicketTypes {
    type: boolean;
    ids: string[];
}

export interface Ticketing {
    hasBadge: boolean;
    hasInsurance: boolean;
    quota: number;
    stock: number;
    taxId: Tax;
    termAndConditions: TermAndConditions;
    bookingTime: number;
    defaultCurrencyId: Currency;
    currenciesIds: Currency[];
    date: TicketingDate;
    ticketVisual: TicketVisual;
    limitAddonAmount?: number;
    minimumAddonAmount?: number;
}

export interface TicketingDate {
    startDate: string;
    endDate: string;
    timezone: string;
}

export interface TicketVisual {
    text: string;
    imageId: Media;
    _image: string;
}

export interface TotalPrice {
    sellingPrice: number
    costPrice: string;
    commission: {
        flat: number;
        percentage: number;
        calculated: number;
    };
    currency: {
        isoCode: string;
        value: number;
    };
    totalPaid: number;
}



// ENUM

export enum DatesType {
    interval = 'interval',
    sessions = 'sessions'
}

export enum FormLocation {
    order = 'order',
    ticket = 'ticket'
}

export enum FormFieldType {
    text = 'textfield',
    textarea = 'textarea',
    email = 'email',
    tel = 'phone',
    date = 'date',
    radio = 'radio',
    checkbox = 'checkbox',
    select = 'select',
    upload = 'upload',
    time = 'time',
    link = 'link',
    number = 'number',
    score = 'score',
    address = 'address'
}
